class MaintenanceWindow {
    static create({urlParams, maintenanceStart}) {
        var msToStartTime = this.resolveMsToStartTime({urlParams, maintenanceStart});

        return new MaintenanceWindow({msToStartTime});
    }

    static resolveMsToStartTime({urlParams, maintenanceStart}) {
        if (urlParams.hasTestMinutesUntilDown()) {
            let minutesString = urlParams.getTestMinutesUntilDown(),
                minutesInt = parseInt(minutesString, 10),
                isValid = minutesInt.toString() === minutesString;

            return isValid ? (minutesInt * 60 * 1000) : null;
        }
        else if (maintenanceStart !== '') {
            let date = new Date(maintenanceStart),
                isValid = date.toString() !== 'Invalid Date';

            return isValid ? (date.getTime() - Date.now()) : null;
        }

        return null;
    }

    constructor({msToStartTime}) {
        this.msToStartTime = msToStartTime;
    }

    didStart() {
        return this.hasMsToStartTime() && this.msToStartTime <= 0;
    }

    getMsToStartTime() {
        return this.msToStartTime;
    }

    hasMsToStartTime() {
        return Number.isInteger(this.msToStartTime);
    }

    startsWithinFourHours() {
        return this.hasMsToStartTime() && this.msToStartTime > 0 && this.msToStartTime <= (4 * 60 * 60 * 1000);
    }
}

export default MaintenanceWindow;